var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduce_unit"},[_vm._m(0),_c('div',[_c('ul',{staticClass:"unit_picture"},_vm._l((_vm.unit_source),function(item,index){return _c('li',{key:index},[_c('img',{attrs:{"src":item.unit_picture,"alt":""}})])}),0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"title"},[_c('span',[_vm._v("合作机构 - ")])])
}]

export { render, staticRenderFns }